import React from 'react';

import HomeHeroSection from '../components/HomeHeroSection';
import Navbar from '../components/Navbar';
import BYOBSection from '../components/BYOBSection';
import ProductShowcase from '../components/ProductShowcase';
import WhyPartnerUs from '../components/WhyPartnerUs';
import BusinessBenefits from '../components/BusinessBenefits';
import Testimonials from '../components/Testimonials';
import TopMarquee from '../components/TopMarquee';
import Footer from '../components/Footer';


const Home = () => {
  return (
    <div className="site-page">

      <Navbar />

      <main className="site-page-content">

        <HomeHeroSection />

        <TopMarquee />

        <BYOBSection />

        {/* <ProductShowcase /> */}

        <WhyPartnerUs />

        <BusinessBenefits />

      </main>

      <Footer />

    </div>
  );
};


export default Home;